(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8120],{

/***/ 99344:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ createOrder; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react-app-events/lib/fireEvent.js
var fireEvent = __webpack_require__(93415);
// EXTERNAL MODULE: ./src/helpers/misc/getErrorMessage.ts
var getErrorMessage = __webpack_require__(80102);
// EXTERNAL MODULE: ./src/helpers/posthog/index.ts
var posthog = __webpack_require__(53023);
// EXTERNAL MODULE: ./src/components/Checkout/Confirm/makePayment.ts
var makePayment = __webpack_require__(9337);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 1 modules
var lib = __webpack_require__(50456);
;// CONCATENATED MODULE: ./src/components/Checkout/Confirm/mutation.ts
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  mutation createOrder(\n    $addressId: ID\n    $storeId: ID\n    $menuId: ID\n    $deliveryType: String\n    $time: String\n    $paymentType: String\n    $otherPaymentType: String\n    $tipAmount: Float\n    $cashAmount: Float\n    $nationalId: String\n    $cardId: ID\n    $channel: String\n    $chatCommerceType: String\n    $couponCode: ID\n    $dropOffType: String\n    $tableName: String\n    $orderParams: JSON\n    $billing: JSON\n    $termSignatures: [TermSignatureInput]\n    $idempotencyKey: ID\n    $paymentData: JSON\n    $sessionEmail: String\n    $sessionPhone: String\n    $orderGroupId: ID\n    $isTableOrderV2: Boolean\n    $gift: GiftInput\n    $source: String\n  ) {\n    order: createOrder(\n      addressId: $addressId\n      storeId: $storeId\n      menuId: $menuId\n      deliveryType: $deliveryType\n      time: $time\n      paymentType: $paymentType\n      cashAmount: $cashAmount\n      nationalId: $nationalId\n      channel: $channel\n      chatCommerceType: $chatCommerceType\n      couponCode: $couponCode\n      otherPaymentType: $otherPaymentType\n      cardId: $cardId\n      tipAmount: $tipAmount\n      dropOffType: $dropOffType\n      tableName: $tableName\n      orderParams: $orderParams\n      billing: $billing\n      termSignatures: $termSignatures\n      idempotencyKey: $idempotencyKey\n      paymentData: $paymentData\n      sessionEmail: $sessionEmail\n      sessionPhone: $sessionPhone\n      orderGroupId: $orderGroupId\n      isTableOrderV2: $isTableOrderV2\n      gift: $gift\n      source: $source\n    ) {\n      _id\n      code\n      paymentStatus\n      paymentType\n      totalPrice\n      totalItems\n      amountToPay\n      tipAmount\n      tableName\n      dropOffType\n      deliveryFee\n      orderGroupId\n      isTableOrderV2\n      items {\n        product {\n          _id\n          name\n          categories {\n            _id\n            internalName\n          }\n        }\n        amount\n        unitPrice\n      }\n      transaction {\n        _id\n        publicMeta\n      }\n      intent {\n        _id\n        intentPayload\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var mutation = ((0,lib["default"])(_templateObject()));

;// CONCATENATED MODULE: ./src/components/Checkout/Confirm/createOrder.ts
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

/* eslint-disable @typescript-eslint/ban-types */ 




function createOrder(_) {
    return _createOrder.apply(this, arguments);
};
function _createOrder() {
    _createOrder = _asyncToGenerator(runtime_default().mark(function _callee(param) {
        var mutate, history, options, setErrorMessage, setVerifyPhone, setCreateCard, setCVC, regenerateIdempotencyKey, paymentData, order, ref, graphQLErrors, validationErrors;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    mutate = param.mutate, history = param.history, options = param.options, setErrorMessage = param.setErrorMessage, setVerifyPhone = param.setVerifyPhone, setCreateCard = param.setCreateCard, setCVC = param.setCVC, regenerateIdempotencyKey = param.regenerateIdempotencyKey, paymentData = param.paymentData;
                    _ctx.prev = 1;
                    _ctx.next = 4;
                    return mutate({
                        mutation: mutation,
                        variables: _objectSpread({}, options, {
                            paymentData: paymentData
                        }),
                        refetchQueries: [
                            "getMyOrderPreferences",
                            "getUserOrderGroup"
                        ]
                    });
                case 4:
                    order = _ctx.sent.order;
                    if (options.isTableOrderV2) {
                        _ctx.next = 8;
                        break;
                    }
                    _ctx.next = 8;
                    return (0,makePayment/* default */.Z)(order, history);
                case 8:
                    (0,posthog.sendPosthogData)(posthog.EVENTS.pay.passValidations);
                    return _ctx.abrupt("return", order);
                case 12:
                    _ctx.prev = 12;
                    _ctx.t0 = _ctx["catch"](1);
                    ref = _slicedToArray(_ctx.t0 && _ctx.t0.graphQLErrors ? _ctx.t0.graphQLErrors : [], 1), graphQLErrors = ref[0];
                    (0,posthog.sendPosthogData)(posthog.EVENTS.pay.failed, _objectSpread({}, graphQLErrors));
                    if (_ctx.t0.graphQLErrors && regenerateIdempotencyKey) {
                        regenerateIdempotencyKey();
                    }
                    if (graphQLErrors && graphQLErrors.validationErrors) {
                        validationErrors = graphQLErrors.validationErrors;
                        if (validationErrors.paymentType === "required") {
                            setErrorMessage("Por favor selecciona un medio de pago");
                        } else if (validationErrors.cardId === "required") {
                            setCreateCard(true);
                        } else if (validationErrors.cardId === "cardIncompatibleWithCoupon") {
                            setErrorMessage("Tarjeta de cr\xe9dito no compatible con descuento");
                        } else if (validationErrors.cvc === "required") {
                            setCVC(true);
                        } else if (validationErrors.cashAmount === "required") {
                            setErrorMessage("Por favor dinos con cuanto vas a pagar para llevar vuelto");
                        } else if (validationErrors.nationalId === "required" || validationErrors.nationalId === "invalid") {
                            setErrorMessage("El n\xfamero de identificaci\xf3n nacional ingresado es inv\xe1lido");
                        } else if (validationErrors.phone === "required") {
                            setErrorMessage("Por favor escribe tu tel\xe9fono, es necesario para llamarte si tenemos dudas");
                        } else if (validationErrors.phone === "requireVerification") {
                            setVerifyPhone({
                                single: false
                            });
                        } else if (validationErrors.phone === "requireSingleUseVerification") {
                            setVerifyPhone({
                                single: true,
                                verificationId: validationErrors.verificationId
                            });
                        } else if (validationErrors.fraud === "retry") {
                            (0,fireEvent["default"])("suggestPaymentChange", validationErrors);
                            setErrorMessage(validationErrors.clientMessage);
                        } else if (Object.keys(validationErrors).find(function(errorKey) {
                            return errorKey.startsWith("orderParams");
                        })) {
                            (0,fireEvent["default"])("orderParamsError", validationErrors);
                        } else if (validationErrors.orderGroupId === "closed") {
                            setErrorMessage(validationErrors.message);
                        }
                    } else {
                        (0,fireEvent["default"])("createOrderError", _ctx.t0);
                        setErrorMessage((0,getErrorMessage/* default */.Z)(_ctx.t0));
                    }
                case 18:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                1,
                12
            ]
        ]);
    }));
    return _createOrder.apply(this, arguments);
}


/***/ }),

/***/ 92870:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ getOptions; }
});

// EXTERNAL MODULE: ./src/helpers/labels/integrationPaymentTypes.ts
var integrationPaymentTypes = __webpack_require__(29909);
// EXTERNAL MODULE: ./src/hooks/useSessionStorageState.ts
var useSessionStorageState = __webpack_require__(11612);
;// CONCATENATED MODULE: ./src/components/Checkout/Confirm/getDefaultOptions.ts
var getDefaultOptions = function() {
    return {
        orderParams: null,
        billing: null,
        addressId: null,
        channel: null,
        tipAmount: null,
        itemsPrice: null,
        amountToPay: null,
        storeId: null,
        menuId: null,
        deliveryType: null,
        dropOffType: null,
        time: null,
        paymentType: null,
        couponCode: null,
        tableName: null,
        cashAmount: null,
        nationalId: null,
        cardId: null,
        otherPaymentType: null,
        skipPhoneValidation: true,
        sessionEmail: null,
        sessionPhone: null,
        chatCommerceType: null
    };
};
/* harmony default export */ var Confirm_getDefaultOptions = (getDefaultOptions);

;// CONCATENATED MODULE: ./src/components/Checkout/Confirm/getOptions.ts
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}



function getOptions(param) {
    var preferences = param.preferences;
    if (preferences.isIncognitoSession) {
        var incognitoSessionPaymentType;
        if (preferences.incognitoSessionPreferences.incognitoSessionPaymentType) incognitoSessionPaymentType = preferences.incognitoSessionPreferences.incognitoSessionPaymentType;
        return {
            options: _objectSpread({}, Confirm_getDefaultOptions(), preferences, {
                paymentType: incognitoSessionPaymentType
            })
        };
    }
    var cart = preferences.cart, deliveryType = preferences.deliveryType, channel = preferences.channel, address = preferences.address, time = preferences.time, paymentType = preferences.paymentType, cashAmount = preferences.cashAmount, nationalId = preferences.nationalId, otherPaymentType = preferences.otherPaymentType, menuId = preferences.menuId, store = preferences.store, cardId = preferences.cardId, couponCode = preferences.couponCode, tableName = preferences.tableName, orderParams = preferences.orderParams, billingParams = preferences.billingParams, sessionEmail = preferences.sessionEmail, sessionPhone = preferences.sessionPhone, chatCommerceType = preferences.chatCommerceType, gift = preferences.gift;
    var calculatedTipAmount = cart.calculatedTipAmount, itemsPrice = cart.itemsPrice, amountToPay = cart.amountToPay;
    if (!preferences.store) {
        if (deliveryType === "delivery") {
            return {
                missingFields: "Por favor indica tu direcci\xf3n de despacho"
            };
        } else {
            return {
                missingFields: "Selecciona un local"
            };
        }
    }
    // if (deliveryType === 'delivery' && address) {
    //   if (!address.addressLine2 && !address.acceptsNoLine2) {
    //     return {
    //       missingFields:
    //         'Debes indicar si tu dirección de entrega es una casa o el número de departamento y guardar'
    //     }
    //   }
    // }
    var payingCashOnDelivery = paymentType === "cash" && deliveryType === "delivery";
    var options = {
        orderParams: orderParams,
        billing: billingParams,
        addressId: deliveryType === "delivery" ? address ? address._id : null : null,
        channel: channel,
        tipAmount: integrationPaymentTypes/* default.includes */.Z.includes(paymentType) ? calculatedTipAmount : null,
        itemsPrice: itemsPrice,
        amountToPay: amountToPay,
        storeId: store._id,
        menuId: menuId,
        deliveryType: deliveryType,
        dropOffType: preferences.dropOffType,
        time: time,
        paymentType: paymentType,
        couponCode: couponCode,
        tableName: tableName,
        cashAmount: payingCashOnDelivery ? cashAmount : null,
        nationalId: nationalId,
        cardId: cardId,
        otherPaymentType: paymentType === "other" && deliveryType === "delivery" ? otherPaymentType : null,
        skipPhoneValidation: deliveryType === "serve",
        sessionEmail: sessionEmail,
        sessionPhone: sessionPhone,
        chatCommerceType: chatCommerceType,
        gift: gift,
        source: (0,useSessionStorageState/* getSavedValue */.z)("orderSource", "web") || "web"
    };
    return {
        options: options
    };
};


/***/ }),

/***/ 76160:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getRedirectUrl; }
/* harmony export */ });
function getRedirectUrl(param) {
    var paymentType = param.paymentType, transaction = param.transaction, intent = param.intent;
    if (!transaction && !intent) return {};
    if ([
        "orion",
        "khipu",
        "amipass",
        "sodexo",
        "kushkiWebpay"
    ].includes(paymentType)) {
        var publicMeta = transaction.publicMeta;
        return {
            url: publicMeta.start,
            post: false
        };
    }
    if ([
        "webpay",
        "webpayCurry",
        "webpayTest",
        "webpayOrioneat"
    ].includes(paymentType)) {
        var publicMeta1 = transaction.publicMeta;
        return {
            url: publicMeta1.start,
            post: true
        };
    }
    if ([
        "kushkiCOPSE"
    ].includes(paymentType)) {
        var start = intent.intentPayload.start;
        return {
            url: start,
            post: false
        };
    }
    return {};
};


/***/ }),

/***/ 9337:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ makePayment; }
/* harmony export */ });
/* harmony import */ var _codebuild_output_src368230298_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _codebuild_output_src368230298_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src368230298_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _getRedirectUrl__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76160);
/* harmony import */ var _redirect__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91995);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



function makePayment(order, router) {
    return _makePayment.apply(this, arguments);
};
function _makePayment() {
    _makePayment = _asyncToGenerator(_codebuild_output_src368230298_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(order, router) {
        var ref, url, post;
        return _codebuild_output_src368230298_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ref = (0,_getRedirectUrl__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                        paymentType: order.paymentType,
                        transaction: order.transaction,
                        intent: order.intent
                    }), url = ref.url, post = ref.post;
                    if (post === true) {
                        (0,_redirect__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(url);
                    } else if (url) {
                        window.location.href = url;
                    } else {
                        router.replace("/track/".concat(order._id));
                    }
                case 2:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _makePayment.apply(this, arguments);
}


/***/ }),

/***/ 91995:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ redirect; }
/* harmony export */ });
function redirect(param) {
    var url = param.url, token = param.token;
    var f = document.createElement("form");
    f.action = url;
    f.method = "POST";
    var i = document.createElement("input");
    i.type = "hidden";
    i.name = "token_ws";
    i.value = token;
    f.appendChild(i);
    document.body.appendChild(f);
    f.submit();
};


/***/ }),

/***/ 69073:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ logout; }
/* harmony export */ });
/* harmony import */ var _codebuild_output_src368230298_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _codebuild_output_src368230298_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src368230298_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _providers_apollo_saveJWT__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31010);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}


// pendiente borrar el refresh token en el server
function logout() {
    return _logout.apply(this, arguments);
};
function _logout() {
    _logout = _asyncToGenerator(_codebuild_output_src368230298_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        return _codebuild_output_src368230298_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    (0,_providers_apollo_saveJWT__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({});
                case 1:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _logout.apply(this, arguments);
}


/***/ }),

/***/ 29909:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ([
    "mercadoPagoCard",
    "mercadoPagoCardMX",
    "mercadoPagoCardCO",
    "stripeMX",
    "kushkiPE",
    "kushkiCO",
    "kushkiCOPSE",
    "kushkiCL",
    "kushkiAsyncCL",
    "kushkiWebpay",
    "webpayOneClick",
    "webpayOneClickTest",
    "webpayOrioneat",
    "webpayTest",
    "khipu",
    "webpay",
    "webpayCurry",
    "orion",
    "amipass",
    "sodexo",
    "mach",
    "chek",
    "fpay",
    "payUCOCard",
    "fpayPE",
    "kushkiEC",
    "proSuenos",
    "epaymentsCR",
    "paypalMX",
    "placeToPayCardEC",
    "bankTransfer",
    "niubizPE",
    "niubizButtonPE"
]);


/***/ }),

/***/ 80102:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ showMessage; }
/* harmony export */ });
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12284);

function getValidationErrorString(param) {
    var validationErrors = param.validationErrors;
    var keys = Object.keys(validationErrors);
    var texts = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            var code = validationErrors[key];
            if (next_i18next__WEBPACK_IMPORTED_MODULE_0__/* .i18n.t */ .ag.t) {
                var text = next_i18next__WEBPACK_IMPORTED_MODULE_0__/* .i18n.t */ .ag.t("errors.".concat(code), {
                    label: key,
                    ns: "deprecated"
                });
                texts.push(text);
            } else {
                texts.push("".concat(key, ": ").concat(code));
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return texts.join(", ");
}
function showMessage(message) {
    if (typeof message === "string") {
        return message;
    } else if (message.graphQLErrors) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = message.graphQLErrors[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var graphError = _step.value;
                if (graphError.error === "validationError") {
                    return getValidationErrorString(graphError);
                } else {
                    return graphError.message;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    } else if (message.message) {
        return message.message;
    } else {
        return message;
    }
};


/***/ }),

/***/ 60839:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useIdempotencyKey; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _helpers_misc_generateId__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6882);


function useIdempotencyKey() {
    var key = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)((0,_helpers_misc_generateId__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(32));
    return {
        idempotencyKey: key.current,
        regenerateIdempotencyKey: function() {
            key.current = (0,_helpers_misc_generateId__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(32);
        }
    };
};


/***/ }),

/***/ 76709:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useWebsiteInfo; }
/* harmony export */ });
/* harmony import */ var _hooks_useWebsiteId__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(16825);
/* harmony import */ var _packages_apollo_hooks__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25074);
/* harmony import */ var _packages_apollo_hooks__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_packages_apollo_hooks__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _page_components_Layout_useInitialData__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62832);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50456);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n      query getWebsiteInfo($websiteId: ID) {\n        website(websiteId: $websiteId) {\n          _id\n          name\n          description\n          countryCode\n          timezone\n          country {\n            canSendDevolutionDataEmail\n            locale\n          }\n          foodCategoriesCodes\n          baseURL\n        }\n      }\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




// returns only the most general website information
function useWebsiteInfo() {
    var websiteId = (0,_hooks_useWebsiteId__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
    var initialData = (0,_page_components_Layout_useInitialData__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    var website = (0,_packages_apollo_hooks__WEBPACK_IMPORTED_MODULE_1__.useApolloQuery)({
        query: (0,graphql_tag__WEBPACK_IMPORTED_MODULE_3__["default"])(_templateObject()),
        variables: {
            websiteId: websiteId
        },
        fetchPolicy: "cache-first",
        omit: !websiteId || !!initialData
    }).website;
    if (initialData) {
        website = initialData.website;
    }
    if (!website) return {};
    return {
        websiteId: website._id,
        websiteName: website.name,
        websiteDescription: website.description,
        websiteCountryCode: website.countryCode,
        websiteCanSendDevolutionDataEmail: website.country.canSendDevolutionDataEmail,
        websiteCategories: website.foodCategoriesCodes,
        websiteTimezone: website.timezone,
        websiteLocale: website.country.locale,
        websiteBaseURL: website.baseURL
    };
};


/***/ }),

/***/ 64582:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Login; }
/* harmony export */ });
/* harmony import */ var _codebuild_output_src368230298_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _codebuild_output_src368230298_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src368230298_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _components_SuspenseLoading__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75288);
/* harmony import */ var _hooks_useState__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48249);
/* harmony import */ var _hooks_useUserId__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77883);
/* harmony import */ var _providers_apollo_saveJWT__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31010);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _LoggedIn__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69085);
/* harmony import */ var _useOnLogin__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(45952);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}











var LoginWithCode = next_dynamic__WEBPACK_IMPORTED_MODULE_7___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3662), __webpack_require__.e(1228), __webpack_require__.e(5445), __webpack_require__.e(191), __webpack_require__.e(791), __webpack_require__.e(7502), __webpack_require__.e(3458), __webpack_require__.e(4336), __webpack_require__.e(8188), __webpack_require__.e(9925), __webpack_require__.e(9207), __webpack_require__.e(7605), __webpack_require__.e(3117)]).then(__webpack_require__.bind(__webpack_require__, 41454));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(41454)
            ];
        }
    },
    loading: _components_SuspenseLoading__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z
});
var RequestCode = next_dynamic__WEBPACK_IMPORTED_MODULE_7___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3662), __webpack_require__.e(1228), __webpack_require__.e(5445), __webpack_require__.e(191), __webpack_require__.e(791), __webpack_require__.e(7502), __webpack_require__.e(3458), __webpack_require__.e(4336), __webpack_require__.e(8188), __webpack_require__.e(9925), __webpack_require__.e(9207), __webpack_require__.e(7605), __webpack_require__.e(1777)]).then(__webpack_require__.bind(__webpack_require__, 25269));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(25269)
            ];
        }
    },
    loading: _components_SuspenseLoading__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z
});
var Register = next_dynamic__WEBPACK_IMPORTED_MODULE_7___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3662), __webpack_require__.e(1228), __webpack_require__.e(5445), __webpack_require__.e(191), __webpack_require__.e(791), __webpack_require__.e(7502), __webpack_require__.e(3458), __webpack_require__.e(4336), __webpack_require__.e(8188), __webpack_require__.e(9925), __webpack_require__.e(9207), __webpack_require__.e(7605), __webpack_require__.e(5693)]).then(__webpack_require__.bind(__webpack_require__, 98211));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(98211)
            ];
        }
    },
    loading: _components_SuspenseLoading__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z
});
function Login(props) {
    var onLogin = (0,_useOnLogin__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)();
    var loading = props.loading, _showRedBorder = props.showRedBorder, showRedBorder = _showRedBorder === void 0 ? false : _showRedBorder;
    var userId = (0,_hooks_useUserId__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)();
    var ref = _slicedToArray((0,_hooks_useState__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(), 2), token = ref[0], setToken = ref[1];
    var ref1 = _slicedToArray((0,_hooks_useState__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(), 2), email = ref1[0], setEmail = ref1[1];
    var onSuccess = function() {
        var _ref = _asyncToGenerator(_codebuild_output_src368230298_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(session) {
            return _codebuild_output_src368230298_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        console.log("Saving new session JWT");
                        _ctx.next = 3;
                        return (0,_providers_apollo_saveJWT__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(session);
                    case 3:
                        if (!onLogin) {
                            _ctx.next = 6;
                            break;
                        }
                        _ctx.next = 6;
                        return onLogin();
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onSuccess(session) {
            return _ref.apply(this, arguments);
        };
    }();
    if (!loading && userId) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_LoggedIn__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {});
    if (token) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(LoginWithCode, {
            token: token,
            onSuccess: onSuccess,
            setToken: setToken,
            email: email
        });
    }
    if (email) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Register, {
            changeEmail: function() {
                return setEmail(null);
            },
            email: email,
            onSuccess: onSuccess
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(RequestCode, {
        setEmail: setEmail,
        setToken: setToken,
        showRedBorder: showRedBorder
    });
};
Login.propTypes = {
    onLogin: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().func),
    loading: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().bool),
    showRedBorder: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().bool)
};


/***/ }),

/***/ 69085:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Logout */
/* harmony import */ var _codebuild_output_src368230298_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _codebuild_output_src368230298_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src368230298_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(89568);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _components_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40076);
/* harmony import */ var _helpers_auth_logout__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69073);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(12284);
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}








var Logout = /*#__PURE__*/ function(_Component) {
    "use strict";
    _inherits(Logout, _Component);
    var _super = _createSuper(Logout);
    function Logout() {
        _classCallCheck(this, Logout);
        return _super.apply(this, arguments);
    }
    var _proto = Logout.prototype;
    _proto.logout = function logout1() {
        return _asyncToGenerator(_codebuild_output_src368230298_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            return _codebuild_output_src368230298_src_codestar_connections_us_east_1_amazonaws_com_git_http_765846071129_us_east_1_2b8358da_528f_4cea_9fc4_c84ee5141e4b_getjusto_justo_services_services_websites_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return (0,_helpers_auth_logout__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    _proto.componentDidMount = function componentDidMount() {
        var to = this.props.router.query.to;
        if (to) {
            this.props.router.replace(Array.isArray(to) ? to[0] : to);
        }
    };
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_7___default().container),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                    children: this.props.t("youAreLoggedIn")
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    onClick: function() {
                        return _this.props.router.replace("/");
                    },
                    children: this.props.t("goHome")
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    onClick: this.logout,
                    danger: true,
                    children: this.props.t("signOut")
                })
            ]
        });
    };
    return Logout;
}(react__WEBPACK_IMPORTED_MODULE_2__.Component);
/* harmony default export */ __webpack_exports__["Z"] = ((0,next_i18next__WEBPACK_IMPORTED_MODULE_6__/* .withTranslation */ .Zh)("auth")((0,next_router__WEBPACK_IMPORTED_MODULE_5__.withRouter)(Logout)));


/***/ }),

/***/ 45952:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useOnLogin; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _helpers_misc_domain_isMainDomain__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54142);


function useOnLogin() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    return function() {
        if (router.query.to) {
            router.replace(Array.isArray(router.query.to) ? router.query.to[0] : router.query.to);
            return;
        }
        if ((0,_helpers_misc_domain_isMainDomain__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)()) {
            router.replace("/");
            return;
        }
        router.replace("/pedir");
    };
};


/***/ }),

/***/ 89568:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"_3-i8h37TCaESh-HYefyNZn"};

/***/ })

}]);